import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import ScrollToTop from "@/components/ScrollToTop";
import PublicLayout from "@/components/PublicLayout";
import ProtectedRoute from "@/components/ProtectedRoute";
import Home from "@/pages/Home";
import ChiSiamo from "@/pages/ChiSiamo";
import Servizi from "@/pages/Servizi";
import Strumentazione from "@/pages/Strumentazione";
import Lavori from "@/pages/Lavori";
import LavoroDetail from "@/pages/LavoroDetail";
import Contatti from "@/pages/Contatti";
import AdminLogin from "@/pages/AdminLogin";
import AdminPasswordForgot from "@/pages/AdminPasswordForgot";
import AdminPasswordReset from "@/pages/AdminPasswordReset";
import AdminChangePassword from "@/pages/AdminChangePassword";
import AdminDashboard from "@/pages/AdminDashboard";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <PublicLayout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/chi-siamo" element={<ChiSiamo />} />
            <Route path="/servizi" element={<Servizi />} />
            <Route path="/strumentazione" element={<Strumentazione />} />
            <Route path="/lavori" element={<Lavori />} />
            <Route path="/lavori/:slug" element={<LavoroDetail />} />
            <Route path="/contatti" element={<Contatti />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin/password-dimenticata" element={<AdminPasswordForgot />} />
            <Route path="/admin/reset-password" element={<AdminPasswordReset />} />
            <Route
              path="/admin/cambia-password"
              element={
                <ProtectedRoute>
                  <AdminChangePassword />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin"
              element={
                <ProtectedRoute>
                  <AdminDashboard />
                </ProtectedRoute>
              }
            />
          </Routes>
        </PublicLayout>
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;
